/* eslint-disable no-console */
import { put, takeEvery, select } from 'redux-saga/effects';
import { getCandidateShareLink, setShareLinkByEmail } from 'api/candidates';
import { openModal, closeModal } from 'actions/modal';
import {
  startShareLinkByEmailSubmit,
  resolveShareLinkByEmailSubmit,
  getShareLink,
} from './actions';

export function* shareLinkByEmailSubmitSaga(action: any) {
  const { token } = yield select(state => state.user);
  const { link, email } = action.payload;
  try {
    const response = yield setShareLinkByEmail(link, email, token);
    if (response) {
      yield put(resolveShareLinkByEmailSubmit());
      yield put(closeModal());
    }
  } catch (error) {
    yield put(resolveShareLinkByEmailSubmit(error.response));
  }
}

export function* getShareLinkSaga(action: any) {
  const { token } = yield select(state => state.user);
  try {
    const shareLink = yield getCandidateShareLink(action.payload, token);
    if (shareLink) {
      yield put(openModal({ title: 'shareLink', data: { url: shareLink.data.url } }));
    }
  } catch (error) {
    console.error(error.response);
  }
}

export default function* shareLinkByEmailSagas() {
  yield takeEvery(startShareLinkByEmailSubmit, shareLinkByEmailSubmitSaga);
  yield takeEvery(getShareLink, getShareLinkSaga);
}
